import React, { ReactNode } from "react";

type HeadingLevel = "h1" | "h2" | "h3" | "h4" | "h5" | "h6";

interface HeadingProps {
  children: ReactNode;
  level?: HeadingLevel;
  className?: string;
  centered?: boolean;
}

const Heading: React.FC<HeadingProps> = ({
  children,
  level = "h2",
  className = "",
  centered = false,
}) => {
  const Component = level as keyof JSX.IntrinsicElements;

  const baseClasses = "font-bold";
  const alignClass = centered ? "text-center" : "";

  return (
    <Component className={`${baseClasses} ${alignClass} ${className}`}>
      {children}
    </Component>
  );
};

export default Heading;
